
import { apiClient } from './client';
import type { ApiResponse } from '../../types/strict';

export interface User {
  id: string;
  name: string;
  email: string;
  phone?: string;
  status?: 'ACTIVE' | 'INACTIVE';
  roleId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface GetUsersQuery {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  filter?:{}
}

export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export interface CreateUserRequest {
  name: string;
  email: string;
  password?: string;
  phone?: string;
  roleId?: string;
}
export interface InviteUsersInBulkRequest {
  users:CreateUserRequest[]
}

export interface UpdateUserRequest {

  userId?: string | number;
  name?: string;
  email?: string;
  phone?: string;
  roleId?: string;
  role:string;
  status?: 'ACTIVE' | 'INACTIVE';
}

export interface AddPaymentCardRequest {
  userId: string;
  cardholderName: string;
  cardNumber?: string;  
  expMonth: number;
  expYear: number;
  brand?: string;
  last4?: string;
}


/* ======================= Service ======================= */

class UsersService {
  private readonly baseUrl = import.meta.env.VITE_API_AUTH_URL;

async getUsers(params?: GetUsersQuery): Promise<ApiResponse<Paginated<User>>> {
    return apiClient.get<Paginated<User>>(`${this.baseUrl}/user`, { params });
  }




  
// service
// async getUsersDirectly(params?: {
//   page?: number;
//   limit?: number;
//   filter?: { role?: (string | number)[] };
// }): Promise<ApiResponse<Paginated<User>>> {
//   const { filter, ...rest } = params ?? {};
//   return apiClient.get<Paginated<User>>(`${this.baseUrl}/user`, {
//     params: {
//       ...rest,
//       ...(filter ? { filter: JSON.stringify(filter) } : {}),
//     },
//   });
// }

  

  async getUserById(userId: string): Promise<ApiResponse<User>> {
    return apiClient.get<User>(`${this.baseUrl}/user/${userId}`);
  }
  async getAllUsersForMe(payload:any): Promise<ApiResponse<any>> {
    console.log("Fetching all users for me with payload:", payload);
    return apiClient.get<User>(`${this.baseUrl}/user/get-all-users-for-me`,{
      params : payload
    });
  }

  async createUser(payload: CreateUserRequest): Promise<ApiResponse<User>> {
    return apiClient.post<User>(`${this.baseUrl}/user`, payload);
  }


  async inviteUser(payload: InviteUsersInBulkRequest): Promise<ApiResponse<User>> {
    return apiClient.post<User>(`${this.baseUrl}/user/invite-user`, payload);
  }
  async acceptInvite(payload: any): Promise<ApiResponse<User>> {
    return apiClient.post<User>(`${this.baseUrl}/user/invite-user-accept`, payload);
  }


async updateUser(userId: string | number, payload: UpdateUserRequest): Promise<ApiResponse<User>> {
    return apiClient.put<User>(`${this.baseUrl}/user/${userId}`, payload);
  }
  
  async deleteUser(userId: string | number): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`${this.baseUrl}/user/${userId}`);
  }
  

  async addPaymentCardDetails(payload: AddPaymentCardRequest): Promise<ApiResponse<void>> {
    return apiClient.post<void>(`${this.baseUrl}/user/payment-card`, payload);
  }
}

export const usersService = new UsersService();
